import PageContent from '@bumble/app/components/PageContent';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box, Button, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';

export const NotFound = () => {
  return (
    <PageContent>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          flexGrow: 1,
          height: `100%`,
        }}
      >
        <Typography variant="h3">Error 404</Typography>
        <Typography variant="subtitle1">Page Not Found</Typography>
        <ErrorOutlineIcon sx={{ fontSize: 50, color: 'error.main', my: 10 }} />
        <Button color="primary" aria-label="home" component={NavLink} to="/main-dashboard">
          Back to the Dashboard
        </Button>
      </Box>
    </PageContent>
  );
};
NotFound.displayName = 'NotFound';
